import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import SafetySheetsLogo from '../../assets/images/login/safety-sheets-logo.png';

const LegalWrapper = styled.div`
    min-height: 100vh;
    margin: 0;
    background: #f5f6f8;
    color: #24303a;
    font: 17px/1.65 system-ui, sans-serif;

    header, main {
        max-width: 860px;
        margin: auto;
        padding: 24px;
    }

    header {
        border-bottom: 3px solid #f78b00;
        padding-top: 36px;
        padding-bottom: 22px;
        text-align: center;
    }

    a {
        color: #12648b;
    }

    .brand {
        display: block;
    }

    .brand img {
        width: min(360px, 85%);
        height: auto;
        display: block;
        margin: 0 auto;
    }

    .provider {
        display: block;
        font-size: 22px;
        font-weight: 700;
        color: #24303a;
        margin-top: 16px;
        letter-spacing: .2px;
    }

    nav {
        margin-top: 22px;
    }

    nav a {
        display: inline-block;
        margin: 0 11px;
        text-decoration: none;
        font-size: 15px;
        font-weight: 600;
    }

    main {
        background: white;
        padding-top: 34px;
        padding-bottom: 40px;
    }

    h1 {
        font-size: 36px;
        line-height: 1.2;
        margin: 0 0 16px;
    }

    h2 {
        font-size: 23px;
        margin-top: 32px;
        color: #b85e00;
    }

    .effective {
        font-size: 14px;
        color: #66737d;
        border-bottom: 1px solid #e4e7eb;
        padding-bottom: 22px;
        margin-bottom: 30px;
    }

    section {
        margin-bottom: 25px;
    }

    @media (max-width: 600px) {
        header, main {
            padding-left: 22px;
            padding-right: 22px;
        }

        h1 {
            font-size: 30px;
        }
    }
`;

export default function LegalLayout({ title, effective, children }) {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = `${title} | Safety Sheets`;
        return () => { document.title = previousTitle; };
    }, [title]);

    return (
        <LegalWrapper>
            <header>
                <a className="brand" href="https://safetysheets.pikegroup.net">
                    <img src={SafetySheetsLogo} alt="Safety Sheets" />
                </a>
                <span className="provider">Pike Consulting Group</span>
                <nav>
                    <Link to="/privacy">Privacy Policy</Link>
                    <Link to="/sms-terms">SMS Terms</Link>
                </nav>
            </header>
            <main>
                <h1>{title}</h1>
                <p className="effective">{effective}</p>
                {children}
            </main>
        </LegalWrapper>
    );
}
